import { db, timestamp } from "../firebase";

export default {
  actions: {
    async fetchAllForms({ commit, getters }) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        const snapshot = await db
          .collection("forms")
          .orderBy("createdAt", "desc")
          .get();

        const docs = [];
        snapshot.docs.forEach(doc => {
          docs.push({
            formId: doc.id,
            ...doc.data()
          });
        });

        return docs;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async submitForm(
      { commit, getters, dispatch },
      { type, message, phone, eventKey }
    ) {
      let formData = {};
      if (type) formData = { ...formData, type };
      if (message) formData = { ...formData, message };
      if (phone) formData = { ...formData, phone };
      if (eventKey) formData = { ...formData, eventKey };

      try {
        const { userId, email } = getters.user;
        await db.collection("forms").add({
          userId,
          userEmail: email,
          createdAt: timestamp,
          ...formData
        });

        if (phone) dispatch("updateUser", { phone, [type]: false });

        commit("setError", "form/submitted");
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    }
  }
};
